export const DEFAULT_NUMBER_DECIMAL_PLACES = 2;
export const MIN_NUMBER_DECIMAL_PLACES = 0;
export const MAX_NUMBER_DECIMAL_PLACES = 8;

export const DEFAULT_COLUMN_HEADER_ORIENTATION = 'horizontal' as const;

export const DEFAULT_TABLE_SETTINGS_MODEL = {
  columnsOrderModel: [] as string[],
  columnsVisibility: {} as Record<string, boolean>,
  sortingModel: [] as [],
  columnsWidth: {} as Record<string, number>,
  pinnedColumns: {} as Record<string, never>,
  numberDecimalPlaces: DEFAULT_NUMBER_DECIMAL_PLACES,
  columnHeaderOrientation: DEFAULT_COLUMN_HEADER_ORIENTATION,
};
